module.exports = __webpack_public_path__ + "img/slide8.39733476.jpg";